import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PecasAtendidasService } from '../pecas-atendidas-service/pecas-atendidas.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-pecas-atendidas-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./pecas-atendidas-lista.component.css']
})
export class PecasAtendidasListaComponent 
extends ListaBase
implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: PecasAtendidasService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
   }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("ano", 'parametros.pecaAtendida.ano')
      .addColuna("mes", 'parametros.pecaAtendida.mes')
      .addColuna("valor", 'parametros.pecaAtendida.quantidade')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
    || this.filtros.mes
    || this.filtros.ano
    || this.filtros.id_dealer
    || this.filtros.valor;
  }

}
